import ChatOutlined from "@mui/icons-material/ChatOutlined";
import InfoOutlined from "@mui/icons-material/InfoOutlined";
import Launch from "@mui/icons-material/Launch";
import { colors } from "healthex-common/colors";
import styled from "styled-components";
import { FlexColumnDiv, FlexRowDiv } from "./common.styles";
import { HXMobilePageTitleText, mobilePageHPadding } from "./HXMobilePage.styles";
export const PatientSupportParent = styled(FlexColumnDiv) `
    margin-top: 8px;
    margin-bottom: 24px;
    gap: 24px;
    padding: 0 ${mobilePageHPadding}px;
`;
export const Welcome = styled(FlexColumnDiv) `
    gap: 8px;
`;
export const WelcomeTitle = styled(HXMobilePageTitleText) ``;
export const OtherOptions = styled(FlexColumnDiv) `
    gap: 16px;
`;
export const OtherOptionItem = styled(FlexRowDiv) `
    align-items: center;
    justify-content: space-between;
`;
export const OtherOptionIconAndName = styled(FlexRowDiv) `
    align-items: center;
    gap: 8px;
`;
export const InfoIcon = styled(InfoOutlined) `
    color: ${colors.accents_sunset};
    width: 24px;
    height: 24px;
`;
export const ChatIcon = styled(ChatOutlined) `
    color: ${colors.accents_sunset};
    width: 24px;
    height: 24px;
`;
export const OtherOptionLaunchIcon = styled(Launch) `
    color: ${colors.black_lighter};
`;
